import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Box, Button, ListItem, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	item: {
		display: "flex",
		paddingTop: 0,
		paddingBottom: 0,
		transition: "0.5s",
		zIndex: 1000,
	},
	button: {
		marginTop: 5,
		marginBottom: 15,
		marginRight: 10,
		marginLeft: 10,
		borderRadius: 10,
		justifyContent: "flex-start",
		alignItems: "center",
		letterSpacing: 0,
		transition: "0.2s",
		padding: 10,
		textTransform: "none",
		display: "flex",
		width: "100%",
		textDecoration: "none",
		position: "relative",
		"&:hover": {
			color: theme.palette.secondary.main,
			marginLeft: 20,
			marginRight: -10,
			// boxShadow: "0px 0px 8px 0px " + theme.palette.secondary.main,
			"& $icon": {
				color: theme.palette.secondary.main,
			},
			"& $title": {
				color: theme.palette.secondary.main,
			},
		},
		"&.active": {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.primary.main,
			boxShadow: "0px 0px 8px 0px " + theme.palette.secondary.main,
			marginLeft: 20,
			marginRight: -10,

			"& $title": {
				color: theme.palette.primary.main,
			},
			"& $icon": {
				color: theme.palette.primary.main,
			},
			"&:hover": {
				backgroundColor: theme.palette.secondary.main,
				color: theme.palette.primary.main,
				"& $title": {
					color: theme.palette.primary.main,
				},
				"& $icon": {
					color: theme.palette.primary.main,
				},
			},
		},
		"& $icon": {
			color: theme.palette.secondary.main,
		},
	},
	icon: {
		color: theme.palette.primary.main,
		marginRight: theme.spacing(1),
	},
	title: {
		color: theme.palette.secondary.main,
		fontWeight: 200,
	},
}));

const NavBarItem = ({
	className,
	href,
	icon: Icon,
	title,
	onClose,
	...rest
}) => {
	const classes = useStyles();

	return (
		<ListItem
			className={classes.item}
			disableGutters
			{...rest}
			sx={{ padding: 0 }}
		>
			<Box
				className={classes.button}
				component={RouterLink}
				to={href}
				onClick={onClose}
				color="secondary"
			>
				<Icon className={classes.icon} size="20" />

				<Typography variant="menu" className={classes.title}>
					{title}
				</Typography>
			</Box>
		</ListItem>
	);
};

NavBarItem.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string,
	icon: PropTypes.elementType,
	title: PropTypes.string,
};

export default NavBarItem;
